import { useEffect, FC } from 'react'

import { getPlatformKey } from 'services/Utilities'
import { MFilters } from 'types/filterTypes'
import { useFiltersChange } from './hooks'

import { Button } from 'ui'

type SearchButtonProps = {
  contentName: MFilters.ContentTypes
}

const SearchButton: FC<SearchButtonProps> = ({ contentName }) => {
  const { filtersHaveChanged, triggerSearch } = useFiltersChange(contentName)

  // Intercept ctrl/cmd + Enter key combinaison to trigger research
  useEffect(() => {
    const handleCtrlEnter = (event: KeyboardEvent) => {
      //Get the operating system
      const operatingSystem = getPlatformKey()
      //Get the key character
      const key = event.key

      const ctrlEnterPress = ((operatingSystem === 'WINDOWS' && event.ctrlKey) || (operatingSystem === 'MAC' && event.metaKey)) && key === 'Enter'
      if (ctrlEnterPress && filtersHaveChanged) triggerSearch()
    }
    //Adding the event listener
    window.addEventListener('keydown', handleCtrlEnter)
    //Removing the event listener
    return () => {
      window.removeEventListener('keydown', handleCtrlEnter)
    }
  }, [filtersHaveChanged, triggerSearch])

  if (!filtersHaveChanged) return null

  return (
    <Button type="button" color="primary" size="small" className="ml-2" onClick={() => triggerSearch()}>
      <i className="fas fa-search"></i>
    </Button>
  )
}

export default SearchButton
